import type { Component } from 'vue';

export const getComponentIdentifier = (component: Component): string => {
    const vueComponent = component as Record<string, unknown>;
    
    // 1. __name property (most reliable for SFC)
    if (vueComponent.__name && typeof vueComponent.__name === 'string') {
        return vueComponent.__name;
    }
    
    // 2. name property (if explicitly set)
    if (vueComponent.name && typeof vueComponent.name === 'string') {
        return vueComponent.name;
    }
    
    return 'unknown-component';
};